import { LifeControlOptionsType } from './types';

export const LIFE_CONTROL_OPTIONS: LifeControlOptionsType = [
  {
    id: 'always_in_control',
    title: 'Always. I run the show',
  },
  {
    id: 'try_to_control',
    title: "I try to be, but it's exhausting",
  },
  {
    id: 'go_with_flow',
    title: 'Not really – I go with the flow',
  },
  {
    id: 'no_control',
    title: "Control? What's that?",
  },
];
